import { BackendResponse } from "../BackendResponse";

export interface StartApplyForCurrentPositionResponse extends BackendResponse {
  url: string;
}

export interface StartApplyForCurrentPositionParameters {
  idConcern: number;
}

/** For integration with legacy cvportal */
export type startApplyForCurrentPosition = (
  args: StartApplyForCurrentPositionParameters
) => Promise<StartApplyForCurrentPositionResponse>;

export const startApplyForCurrentPosition: startApplyForCurrentPosition = async (
  args
) => {
  throw new Error("not implemented");
};
